<div class="cart-content" (click)="this.showCart.emit()">
  <div
    class="p-2 d-flex justify-content-between cart-header"
    [style.backgroundColor]="titleBackgroundColor"
  >
    <div></div>
    <div>
      <p class="text-center cart-title">MINHA SACOLA</p>
    </div>
    <div>
      <a class="cart-close-button" (click)="this.hideCart.emit()"
        >X<i class="icofont-close-line"></i
      ></a>
    </div>
  </div>
  <div class="p-2 row cart-items-box">
    <div class="col-12 cart-items mb-3">
      <div *ngFor="let item of items" class="cart-item mb-2">
        <div class="row no-gutters">
          <div
            class="col-md-4 pr-2"
            (click)="redirectTo('/produto/' + item.produto)"
          >
            <img
              src="{{ imageApiProdutos }}{{
                item.nome ? item.nome : item.imagem
              }}"
              class="card-img cart-item-image img-thumbnail"
              alt="Product Image"
            />
          </div>
          <div
            class="col-md-8 pr-2"
            (click)="redirectTo('/produto/' + item.produto)"
          >
            <p class="card-text">
              <span
                ><b class="cart-item-title"
                  >{{ item.produtoReferencia }} -
                  {{
                    item.descricao ? item.descricao : item.produtoDescricao
                  }}</b
                ></span
              >
            </p>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-5 cart-item-data" i18n>
            Quantidade:
            <span
              ><b class="cart-item-data">{{ item.quantidade }}</b></span
            ><br />
          </div>
          <div class="col-5 cart-item-data">
            <span i18n>
              Total:
            </span>
            <span
              ><b class="cart-item-data" i18n>R${{ item.total | currency : "BRL" : "" }}</b></span
            ><br />
          </div>
          <div class="col-md-2 cart-item-remove d-flex flex-row-reverse">
            <button
              (click)="removeItem(item)"
              title="Excluir"
              class="btn btn-outline-danger cart-item-delet-button"
            >
              <i class="icofont-trash"></i>
            </button>
          </div>
        </div>
        <hr width="100%" />
      </div>
    </div>
  </div>
  <div class="cart-footer">
    <div class="p-2 mt-3 d-flex justify-content-between cart-subtotal">
      <div class="d-flex p-2">SUBTOTAL:</div>
      <div class="d-flex p-2">
        {{ total | currency : "BRL" }}
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div class="d-flex p-2">
        <button
          (click)="redirectTo('/catalogo')"
          class="btn btn-outline-dark float-left"
          i18n
        >
          Continuar
        </button>
      </div>
      <div class="d-flex p-2">
        <button
          (click)="redirectTo('/checkout')"
          class="btn btn-outline-dark float-right"
          i18n
        >
          <i class="{{ SITE ? SITE.iconCart : ''}}"></i> Finalizar
        </button>
      </div>
    </div>
  </div>
</div>
